import React from 'react';

import DeskNav from '../layouts/DeskNav';
import '../../styles/projects.scss'; 
import Video from '../../videos/web-looppress.mp4';

export default (props) => {
	
	return (
		<main className='projects'>
			<DeskNav />
			<section className='w-half projects-section'>
				<article className='projects-info'>	
					<p> {props.projects.title}</p>
					<p> {props.projects.text}</p>
					{props.projects.sites.map((site,index) => 
						<a key={index} href={site.url}> {site.name} </a> 
					)}
				</article> 
				
			</section>
			<section className='w-half text-center'>
					<video className='video' autoPlay='autoplay' loop='loop' muted='muted'>
                        <source src={Video} type='video/mp4' />
                        Your browser does not support the video tag.			
                    </video>
			</section>
		</main>
	);
}